// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"eecef2fa","731":"f785212b","922":"778c6987"}[chunkId] + ".chunk.js";
};